import {
	type FetchSocialFeedPartnersByFeedSlugData,
	type FetchSocialFeedPartnersByFeedSlugParams,
	socialApi,
	useLocale
} from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const SOCIAL_FEED_PARTNERS_QUERY_KEY = 'social-feed-partners';

export const useSocialFeedPartnersQuery = (
	params: FetchSocialFeedPartnersByFeedSlugParams,
	options?: Omit<
		UseQueryOptions<FetchSocialFeedPartnersByFeedSlugData, unknown, FetchSocialFeedPartnersByFeedSlugData['data']>,
		'queryFn' | 'queryKey'
	>
) => {
	const { locale } = useLocale();

	return useQuery({
		queryFn: async () =>
			(await socialApi).fetchSocialFeedPartnersByFeedSlug(
				{
					// TODO: GPS-10256: Remove locale once endpoint is updated to use "locales"
					locale,
					...params
				},
				{}
			),
		queryKey: [SOCIAL_FEED_PARTNERS_QUERY_KEY, params, locale],
		select: resp => resp.data,
		...options
	});
};
